import React from 'react';

const Portfolio = () => {
  return (
    <section className="p-10">
      <h2 className="text-4xl font-bold mb-5">Portfolio</h2>
      <p className="text-lg text-gray-700">
        These are the Portfolio I've been working on over the years. I have been involved in both technical and strategic project management.
      </p>
    </section>
  );
};

export default Portfolio;